import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Routes from "../Routes";

import CommonSidebar from "../Common/CommonSidebar/CommonSidebar";
import CommonHeader from "../Common/CommonHeader/CommonHeader";
import CommonBreadcrumb from "../Common/CommonBreadcrumb/CommonBreadcrumb";
import CreateUser from "../components/Auth/CreateUser";
import SuperAdminSidebar from "../Common/SuperAdmin/SuperAdminSidebar";
import { useLocation, useNavigate } from "react-router-dom";

const AdminLayout = ({
  themeMode,
  themeColor,
  borderStroke,
  boxLayout,
  monochrome,
  borderRadius,
  iconColor,
  gradientColor,
}) => {
  const [sidebarHidden, setSidebarHidden] = useState(false);
  const [showCreateUser, setShowCreateUser] = useState(false);
  const user = useSelector((state) => state.auth);

  const toggleSidebar = () => {
    setSidebarHidden((prev) => !prev);
  };

  const location=useLocation();
  const navigate=useNavigate();

  useEffect(()=>{
     if(location.pathname==='/create-admin' && localStorage.getItem('role')==='admin'){
       navigate("/")
     }
  },[location])

  return (
    <div
      data-ha={`theme-${themeColor}`}
      data-bs-theme={themeMode}
      className={`${gradientColor} ${sidebarHidden ? "sidebar-hide" : ""} ${borderStroke} ${boxLayout} ${monochrome} ${borderRadius}`}
      style={{ minHeight: "100vh" }}
    >
      <main
        className={`${boxLayout === "box-layout rightbar-hide" ? "container" : "container-fluid"} px-0`}
      >
        <>
          <CommonSidebar iconColor={iconColor} />
          <div className="content">
            <CommonHeader toggleSidebar={toggleSidebar} />
            {/* <CommonBreadcrumb /> */}
            <Routes />
          </div>
        </>
      </main>
    </div>
  );
};

export default AdminLayout;
